import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import facetType from '../../../utility/types/facetType';
import { store } from '../../../redux/store';

class AlertNotificationGroupsFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = facetType.NOTIFICATION_GROUP;
    this.displayName = 'Notification Groups';
    this.description = 'include...';
    this.state = store.getState();
  }

  // eslint-disable-next-line class-methods-use-this
  getOperatorDescription(operatorType) {
    const operatorTypeId = parseInt(operatorType, 10);
    const operatorDescriptions = {
      [OperatorTypes.EQUAL_TO_VALUE]: 'ANY of the following:',
      [OperatorTypes.EQUAL_TO_BOOLEAN]: 'ALL of the following:',
      [OperatorTypes.NOT_EQUAL_TO]: 'NONE of the following:',
    };
    return operatorDescriptions[operatorTypeId] || '';
  }

  /* istanbul ignore next */
  getName() {
    return this.displayName;
  }

  getDescription() {
    return this.description;
  }

  getDisplayValue1(value) {
    const notificationGroups = this.state.notificationGroups.notificationGroupList;

    const found = notificationGroups.find(
      (group) => parseInt(group.id, 10) === parseInt(value, 10),
    );

    return found ? found.name : '';
  }

  /* istanbul ignore next */
  // eslint-disable-next-line class-methods-use-this
  getValueSelectOptions(notificationGroupList) {
    return (notificationGroupList || []).map((group) => ({
      value: group.id.toString(),
      label: group.name,
    }));
  }

  // eslint-disable-next-line class-methods-use-this
  /* istanbul ignore next */
  getTooltip(filtersByOperatorObj) {
    // Update this path if your slice shape differs.
    const notificationGroups = this.state.notificationGroups.notificationGroupList;

    const nameFor = (filter) => {
      const found = notificationGroups.find(
        (group) => parseInt(filter.value1, 10) === parseInt(group.id, 10),
      );
      return found ? found.name : '';
    };

    return `Notification Groups are ${
      filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
        ? `ANY of ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
          .map(nameFor).filter(Boolean).join(', ')
        };`
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.EQUAL_TO_BOOLEAN]
        ? ` ALL of ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_BOOLEAN]
          .map(nameFor).filter(Boolean).join(', ')
        };`
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
        ? ` NONE of ${filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
          .map(nameFor).filter(Boolean).join(', ')
        };`
        : ''
    }`;
  }
}

export default AlertNotificationGroupsFacet;
